///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { EngineProductDTO } from '../../generated/shared-types.model';

@Injectable({
    providedIn: 'root'
})
export class GtthPdbService {
    constructor(private readonly http: HttpClient) {}

    findEngineProduct(engineProductId: number): Observable<EngineProductDTO> {
        return this.http.get<EngineProductDTO>(`api/engine-products/${engineProductId}`).pipe(
            tap((res) => {
                res.pdbConfig.channelConfigs = [...res.pdbConfig.channelConfigs].sort((a, b) => a.bandwidth - b.bandwidth);
            }),
            catchError(() => of({} as EngineProductDTO))
        );
    }

    findEngineProductOnCompanyLevel(engineProductId: number, companyId?: number): Observable<EngineProductDTO> {
        if (!companyId) {
            companyId = -1;
        }
        return this.http.get<EngineProductDTO>(`api/engine-products/company/${companyId}/${engineProductId}`).pipe(
            tap((res) => {
                res.pdbConfig.channelConfigs = [...res.pdbConfig.channelConfigs].sort((a, b) => a.bandwidth - b.bandwidth);
            }),
            catchError(() => of({} as EngineProductDTO))
        );
    }

    saveProduct(product: EngineProductDTO): Observable<EngineProductDTO> {
        return this.http.post<EngineProductDTO>(`api/engine-products`, product).pipe(catchError(() => of({} as EngineProductDTO)));
    }

    overrideOnCompanyLevel(product: EngineProductDTO): Observable<EngineProductDTO> {
        const companyId = -1;
        return this.http
            .post<EngineProductDTO>(`api/engine-products-override/company/${companyId}`, product)
            .pipe(catchError(() => of({} as EngineProductDTO)));
    }

    removeProduct(productId: number): Observable<void> {
        return this.http.delete<void>(`api/engine-products/${productId}`, {});
    }
}
